import { useMemo } from 'react'
import { Box } from '@mui/material'
import { BaseTable } from 'Features/Table/BaseTable.view'
import { ExtendedGridColDef } from 'Features/Table/BulkUpdateModal'
import {
  SheduleTableProps,
  SchedulerTankEligibilityRowType,
} from './Scheduler.types'

/**
 * Which product a tank may hold — `TankEligibilityDelta`.
 *
 * One row per tank under V1 dedication. Both columns key the row, so adding a
 * second product to a tank is a second row rather than an edit, which is how
 * V2's shared tanks arrive without a table migration.
 */
const dataConfig = {
  required: ['tankId', 'productCode'],
  optional: [],
}

export const SchedulerTankEligibilityTable = ({
  data,
  isLoading,
  updateTableData,
  uploadScheduleData,
  isUploading,
  isSaving,
  updateRowsStatus,
  predicate,
  deleteTableData,
  isDeleting,
}: SheduleTableProps<SchedulerTankEligibilityRowType>) => {
  const handleDataUpdate = (
    changedRows: Record<number, SchedulerTankEligibilityRowType>
  ) => {
    updateTableData(changedRows)
  }

  const columns: ExtendedGridColDef[] = useMemo(
    () => [
      {
        headerName: 'Tank',
        field: 'tankId',
        type: 'string',
        flex: 1,
        editable: true,
      },
      {
        headerName: 'Product Code',
        field: 'productCode',
        type: 'string',
        flex: 1,
        editable: true,
      },
    ],
    []
  )

  return (
    <Box>
      <BaseTable
        data={data ?? []}
        columns={columns}
        isLoading={isLoading}
        updateTableData={handleDataUpdate}
        uploadData={uploadScheduleData}
        isUploading={isUploading}
        isSaving={isSaving}
        checkBoxSelection={true}
        showTableToolBar={true}
        downloadFileName="SchedulerTankEligibility"
        onDeleteRows={deleteTableData}
        isDeleting={isDeleting}
        multiStageUpload={{
          uploadFile: uploadScheduleData,
          isUploading: isUploading,
          columns: columns,
          updateRowsStatus: updateRowsStatus,
          originalData: data,
          predicate: predicate,
          dataConfig: dataConfig,
        }}
        initialState={{
          pagination: { paginationModel: { pageSize: 100 } },
        }}
        sx={{
          maxWidth: 'calc(100vw - 70px)',
          '& .MuiDataGrid-cell--editable': {
            backgroundColor: '#CBD5E1',
          },
          '& .MuiBox-root': {
            padding: '0px !important',
          },
        }}
      />
    </Box>
  )
}
